const FPCSRF = 'fp-csrf'

export default {
  getToken () {
    return window.localStorage.getItem(FPCSRF)
  },

  saveToken (fpCsrf) {
    window.localStorage.setItem(FPCSRF, fpCsrf);
  },

  destroyToken () {
    window.localStorage.removeItem(FPCSRF)
  }
}